import React, { useState } from 'react';
// Import the auth instance AND the specific sign-in function
import { auth } from '../firebase'; // Assuming signInWithEmailAndPassword is NOT exported from here
import { signInWithEmailAndPassword } from 'firebase/auth'; // Import the function directly
import { useNavigate, Link } from 'react-router-dom'; // *** 1. IMPORT Link ***

function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleLogin = async (event) => {
    event.preventDefault();
    setError('');
    try {
      // Use the imported function and auth instance
      await signInWithEmailAndPassword(auth, email, password);
      navigate('/dashboard'); // Redirect to dashboard on successful login
    } catch (err) {
      console.error("Login Error:", err); // Log the full error
      // Provide user-friendly messages for common errors
      if (err.code === 'auth/user-not-found' || err.code === 'auth/wrong-password' || err.code === 'auth/invalid-credential') {
           setError('Invalid email or password.');
      } else if (err.code === 'auth/invalid-email') {
          setError('Please enter a valid email address.');
      } else {
           setError('Failed to log in. Please try again.'); // Generic error
      }
    }
  };

  return (
    <div className="container">
      <div className="row justify-content-center">
        <div className="col-md-6 col-lg-5 col-xl-4"> {/* Adjusted column width for typical login forms */}
          <div className="card mt-5 shadow-sm"> {/* Added shadow */}
            <div className="card-body p-4"> {/* Added padding */}
              <h2 className="card-title text-center mb-4">Sign In</h2> {/* Added margin */}
              {error && <div className="alert alert-danger" role="alert">{error}</div>} {/* Use Bootstrap alert */}
              <form onSubmit={handleLogin}>
                {/* Using mb-3 for Bootstrap 5 spacing */}
                <div className="mb-3">
                  <label htmlFor="email" className="form-label">Email</label>
                  <input
                    type="email"
                    className="form-control"
                    id="email"
                    placeholder="Enter email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                  />
                </div>
                <div className="mb-3">
                  <label htmlFor="password">Password</label>
                  <input
                    type="password"
                    className="form-control"
                    id="password"
                    placeholder="Password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    required
                  />
                </div>
                {/* Using d-grid for full-width button in Bootstrap 5 */}
                <div className="d-grid mt-4">
                    <button type="submit" className="btn btn-primary">
                        Login
                    </button>
                </div>
              </form>

              {/* *** 2. ADDED Forgot Password Link *** */}
              <div className="text-center mt-3">
                <Link to="/forgot-password">Forgot Password?</Link>
              </div>

            </div> {/* End card-body */}
          </div> {/* End card */}
        </div> {/* End col */}
      </div> {/* End row */}
    </div> // End container
  );
}

export default Login;